export default "__VITE_ASSET__B3pO7ypt__"